export const SortOrders = ['desc', 'asc'] as const;
export type SortOrder = (typeof SortOrders)[number];

export type OrderBy = {
  field: string;
  /**
   * Uuid (for rendering purposes)
   */
  id: string;
  sortOrder: SortOrder;
};

export type OrderByWithoutId = Omit<OrderBy, 'id'>;
